import RequestResetPassword from './RequestResetPassword';

export default RequestResetPassword;
